// AI-CONTEXT: See docs/features/participation-ladder.md
import { Fragment } from 'react'
import { PAID_WORK_ACTIVITY } from '../../../helpers/participationHelpers/participationOptions'
import getParticipationFormSpec, { displayBenefitType } from '../../../helpers/participationHelpers/getParticipationFormSpec'

// Read-only key/value summary of the recorded answers for a moment, shown for
// the locked beginsituatie instead of the editable form. Zelfde vragen als het
// formulier onder de vastgezette parameterset.
/**
 * @param {object} props
 * @param {object} [props.profile] - Het opgeslagen profiel van dit meetmoment
 * @param {object|null} props.parameters - De vastgezette parameterset; bepaalt welke antwoorden er staan
 */
const ParticipationLockedSummary = ({ profile = {}, parameters }) => {
    const spec = getParticipationFormSpec(parameters)
    const isPaidWork = profile.mainActivity === PAID_WORK_ACTIVITY
    const rows = []

    rows.push(['Wat doe je op dit moment?', profile.mainActivity || '-'])
    if (profile.mainActivity === 'Niet actief') {
        rows.push(['Hoe ziet je situatie eruit?', profile.inactivityLevel || '-'])
    }
    if (isPaidWork) {
        rows.push(['Hoeveel uur per week?', profile.hoursBand || '-'])
        if (Number.isFinite(profile.employabilityFactor)) {
            rows.push(['Inzetbaarheid', `${Math.round(profile.employabilityFactor * 100)}%`])
        }
        if (spec.askLoonkostensubsidie && typeof profile.loonkostensubsidie === 'boolean') {
            rows.push(['Loonkostensubsidie', profile.loonkostensubsidie ? 'Ja' : 'Nee'])
        }
    }
    if (isPaidWork || profile.mainActivity === 'Opleiding') {
        rows.push(['Hoogst afgeronde opleiding', profile.educationLevel || '-'])
    }
    if (profile.mainActivity === 'Opleiding' && spec.educationTargetOptions.length > 0) {
        rows.push(['Naar welk niveau leidt de opleiding?', profile.educationTarget || '-'])
    }
    if (profile.mainActivity === 'Vrijwilligerswerk') {
        rows.push(['Vrijwilligersuren per week', `${Number(profile.volunteerHoursPerWeek) || 0} uur`])
    }
    rows.push(['Ontvang je een uitkering?', displayBenefitType(profile.benefitType, parameters) || 'Geen'])
    if (spec.askBenefitShare && profile.benefitType === 'Bijstandsuitkering' && Number.isFinite(profile.benefitShare)) {
        rows.push(['Deel van de volledige bijstand', `${Math.round(profile.benefitShare * 100)}%`])
    }
    if (spec.dagbestedingOptions.length > 0) {
        const hasDagbesteding = Boolean(profile.dagbesteding) && profile.dagbesteding !== 'Geen'
        rows.push(['Dagbesteding', hasDagbesteding ? `${profile.dagbesteding}, ${Number(profile.dagdelenPerWeek) || 0} dagdelen per week` : 'Geen'])
    }

    return (
        <div className="participation-locked-grid">
            {rows.map(([label, value]) => (
                <Fragment key={label}>
                    <div className="lk-label">{label}</div>
                    <div className="lk-value">{value}</div>
                </Fragment>
            ))}
        </div>
    )
}

export default ParticipationLockedSummary
